export const MachineApprovalStatus = {
  APPROVAL: 'APPROVAL',
  PSWAITING: 'PSWAITING',
  WAITING: 'WAITING',
  REJECT: 'REJECT',
} as const;

export type MachineApprovalStatusType = keyof typeof MachineApprovalStatus;

export const MACHINE_ROW_OPTIONS = [
  {
    label: '2조식',
    value: '2조식',
  },
  {
    label: '3조식',
    value: '3조식',
  },
  {
    label: '4조식',
    value: '4조식',
  },
  {
    label: '5조식',
    value: '5조식',
  },
  {
    label: '6조식',
    value: '6조식',
  },
  {
    label: '7조식',
    value: '7조식',
  },
  {
    label: '8조식',
    value: '8조식',
  },
  {
    label: '보통형',
    value: '보통형',
  },
];

export const TRANSPLANTER_ROW_OPTIONS = [
  {
    label: '4조식',
    value: '4조식',
  },
  {
    label: '5조식',
    value: '5조식',
  },
  {
    label: '6조식',
    value: '6조식',
  },
  {
    label: '7조식',
    value: '7조식',
  },
  {
    label: '8조식',
    value: '8조식',
  },
  {
    label: '9조식',
    value: '9조식',
  },
  {
    label: '10조식',
    value: '10조식',
  },
];
